import React from "react";
import { Link } from "react-router-dom";

const formatDate = (iso) => {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
  } catch {
    return "";
  }
};

export const IssueCard = ({ issue, featured = false }) => {
  if (!issue) return null;
  return (
    <Link
      to={`/issues/${issue.slug}`}
      data-testid="issue-card"
      className={`group block ${featured ? "lg:col-span-2" : ""}`}
    >
      <div className="nb-box nb-interactive h-full p-6 sm:p-7">
        {featured && (
          <div className="mb-4 inline-flex items-center border-2 border-[color:var(--coh-ink)] bg-[color:var(--coh-blue)] px-2 py-1 font-mono text-[11px] font-semibold uppercase tracking-[0.14em] text-[color:var(--coh-on-accent)]">
            Featured <span aria-hidden="true" className="ml-1">↓</span>
          </div>
        )}
        <div className="flex items-center gap-3 text-xs text-[color:var(--coh-ink-muted)] font-mono">
          <span className="text-[color:var(--coh-blue)]">#{String(issue.issue_number).padStart(3, "0")}</span>
          <span>·</span>
          <span>{formatDate(issue.published_at || issue.updated_at)}</span>
          {issue.theme && (<><span>·</span><span className="uppercase tracking-[0.14em]">{issue.theme}</span></>)}
        </div>
        <h3 className={`mt-3 font-display ${featured ? "text-3xl sm:text-4xl" : "text-2xl"} font-extrabold tracking-tight leading-tight text-[color:var(--coh-ink)] group-hover:text-[color:var(--coh-blue)] transition-colors`}>
          {issue.title}
        </h3>
        {issue.excerpt && <p className="mt-3 text-sm sm:text-base text-[color:var(--coh-ink-muted)] max-w-prose leading-relaxed">{issue.excerpt}</p>}
        <div data-testid="issue-card-read-link" className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-[color:var(--coh-blue)]">
          Read issue <span aria-hidden="true" className="font-mono transition-transform group-hover:translate-x-1">↗</span>
        </div>
      </div>
    </Link>
  );
};
